export default __webpack_public_path__ + "static/patent_9-aeb292316032b6531bad8578c1aec7ef.jpg";